import { NgForm } from '@angular/forms';
import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { PostulacionesService } from '../../services/postulaciones/postulaciones.service';
import Swal from 'sweetalert2';
import { MantenedorProveedorService } from 'src/app/services/mantenedor-proveedor/mantenedor-proveedor.service';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';

export interface DialogData 
{
    regionesDirDat:any,
    regiones:any,
    idProveedor:any,
    rutProveedor : any,
    dvProveedor: any,
    nombreCorto: any,
    nombreProveedor: any,
    fechaEf : any,
    direccion : any,
    ciudad : any,
    region :any

}
declare const Rut: any;
@Component({
    selector: 'dialog-overview-example-dialog',
    templateUrl: '../../pages/mantenedor-proveedor/crear-proveedor.component.html',
    styleUrls: ['../../pages/mantenedor-proveedor/mantenedor-proveedor.component.css']
})
export class DialogCrearProveedor
{  
    regiones:any
    comunas:any
    cuotas: any
    categorias:any
    proveedor:any ={
        idProveedor : '',
        rutProveedor: '',
        nombreCorto: '',
        nombreProveedor: '',
        direccion: '' ,
        idRegion:0,
        idComuna: 0,
        comunas:'',
        regiones: '',
        rut:'',
        idCategoria:0,
        idCuotas:0,
        minCuotas:0,
        codigoFin:''
    }
    constructor( public dialogRef: MatDialogRef<DialogCrearProveedor>, 
        private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: DialogData, 
                 private mantenedorProveedorService: MantenedorProveedorService) 
    {     }

    ngOnInit(): void {this.loadData()}

    loadData()
    {
        let vm = this
        this.mantenedorProveedorService.traeRegionesEspeciales().then
        ( regiones => { vm.regiones = regiones } )
        this.mantenedorProveedorService.traeCantidadCuotas().then(cuota =>this.cuotas = cuota).catch(error => console.log(error))

        this.mantenedorProveedorService.traeCategoriaConvenio().then(response =>  this.categorias = response
            ).catch(error => console.log(error))
    }
    cargaComunas(region:any){
        this.comunas = []
        console.log("carga comunas de la región ",region)
        this.mantenedorProveedorService.traeComunas(
            region).then(comunas =>this.comunas = comunas).catch(error => console.log(error)) 
    }
    onCancelarClick():void { this.dialogRef.close() } 

    openAlertDialog(mensaje: string, clase: string)  
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }
    onCrearProveedorClick(form: NgForm){
        let vm = this;
        console.log("this.proveedor ",this.proveedor);
        const dialogRef = this.dialog.open(ConfirmationDialog,
          {
              data: { message: '¿Esta seguro de Ingresar un nuevo Proveedor?', buttonText: { ok: 'Si', cancel: 'No' } }
          })
        dialogRef.afterClosed().subscribe((confirmed: boolean) =>
        {
          if (confirmed){
            Swal.fire({
                allowOutsideClick:false,
                icon:'info',
                text:'Cargando...'
              });
              Swal.showLoading();
              this.mantenedorProveedorService.ingresarProveedor(localStorage.getItem("idUsuario"),this.proveedor).
              then(
                ()=>
                  {
                    
                    this.openAlertDialog('El Proveedor fue ingresada exitosamente.', 'btn-success');
                    form.reset();
                    Swal.close();
                    this.dialogRef.close()
                  }
              )
              .catch ( error =>
                {
                    console.log(error)
                    Swal.close();
                    this.openAlertDialog('Ha ocurrido un error al ingresar un proveedor.', 'btn-danger')
                } )
          }
        })
    }
  }
/*
        this.mantenedorService.traeEstadoCivil().then( estados => vm.data.estadoCivil = estados )
        this.mantenedorService.traePrevision().then( previsiones => vm.data.prevision = previsiones )
        this.mantenedorService.traeSistemaSalud().then( sistemas => vm.data.sistemaSalud = sistemas )
        this.mantenedorService.traeRegiones().then
        ( regiones => { vm.data.regiones = regiones, vm.data.regionesDirDat = regiones } )
        this.mantenedorService.traeRoles().then( roles => vm.data.roles = roles )
    }

    traeComunas()
    {
        let vm = this

        this.data.comunas = []

        this.mantenedorService.traeComunas(this.usuario.direccion.region).then( comunas => vm.data.comunas = comunas )
    }

    traeComunasDirDat()
    {
        let vm = this
        
        this.data.comunasDirDat = []

        this.mantenedorService.traeComunas(this.usuario.datosLaborales.direccion.region)
        .then( comunas => vm.data.comunasDirDat = comunas )
    }

    crearUsuario(): void 
    {
        let vm = this
        let fn = new Date(this.usuario.fechaNacimiento);   
        let fi = new Date(this.usuario.fechaIngreso);
        if(fn.getTime() < fi.getTime()){      
            if(Rut( this.usuario.rut)){      
                this.usuario.roltmp = []            
                if(this.usuario.rol !=null && this.usuario.rol.length > 0) {
                    this.usuario.rol.forEach( (element: any, i: number) =>{
                        this.usuario.roltmp.push( { id:element, idUsuarioRol:element } ) 
                    }) 
                }       
                this.usuario.rol=[]      
                if(this.usuario.roltmp !=null && this.usuario.roltmp.length > 0) {
                    this.usuario.rol= this.usuario.roltmp
                }
                let fechaNacimiento = this.usuario.fechaNacimiento.split('-')[2] + '-' + 
                                    this.usuario.fechaNacimiento.split('-')[1] + '-' + 
                                    this.usuario.fechaNacimiento.split('-')[0]

                let fechaIngreso = this.usuario.fechaIngreso.split('-')[2] + '-' + 
                                this.usuario.fechaIngreso.split('-')[1] + '-' + 
                                this.usuario.fechaIngreso.split('-')[0]
                
                this.usuario.fechaNacimiento = fechaNacimiento, this.usuario.fechaIngreso = fechaIngreso

                this.mantenedorService.creaUsuario(this.usuario).then
                ( 
                    () => 
                    {
                        vm.openAlertDialog('El usuario se ha creado exitosamente.', 'btn-success')     

                        vm.data.recarga = true
                        vm.dialogRef.close()   
                    }
                )
                .catch(error => 
                { 
                    console.log(error) 

                    vm.openAlertDialog('Ha ocurrido un error al crear el Usuario', 'btn-danger')    
                    vm.dialogRef.close() 
                })
            }else{
                this.openAlertDialog('El RUT del usuario es incorrecto. Favor Revisar', 'btn-danger') 
            }
        }else{
            this.openAlertDialog('La fecha de nacimiento debe ser menor a la fecha de ingreso', 'btn-danger') 
        } 
    }

    onCancelarClick(): void { this.dialogRef.close() }  
    
    
}*/